import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService } from '@app/services/admin/admin.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-admin-connect-accesses-and-roles-edit',
  templateUrl: './admin-connect-accesses-and-roles-edit.component.html'
})
export class AdminConnectAccessesAndRolesEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  // @Input() roles;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  roles: SelectItem[] = [];
  form;
  

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService) { }

    ngOnInit(): void {
      this.form = this.fb.group({
        roleId: ['', ''],
        oldRole: ['', ''],
        roleDescription: ['', '']
      });
    }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
      this.getFilteredRoles(this.formdata.institutionTypeName, this.formdata.institutionShortName);
    }
  }

  saveConnection() {
    this.formdata['roleId'] = this.form.get('roleId').value;
    this.doSave.emit(this.formdata);
  }

  cancel() {
    this.doCancel.emit();
  }

  getFilteredRoles(institutionTypeName: string, institutionShortName: string) {
    this.adminService.GetFilteredRoles(institutionTypeName, institutionShortName).subscribe(data => {
      this.roles = [];
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          this.roles.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.roles.unshift(emptyrecord);
      }
    });
  }

  setRole(evt) {
    this.form.patchValue({ roleId: evt.value });
    this.form.patchValue({ oldRole: this.formdata['roleDescription'] });
  }
}
